
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect, useMemo, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { APP_CONFIG } from '@constants';
import { flowType } from '@utility/userInfo';
import SimpleReactSelect from '@formElements/SimpleReactSelect/indexRevamp';
import PhoneNumberComponent from '@components/common/PhoneNumberComponent/indexRevamp';
import cn from 'classnames';
import { isEmpty } from 'lodash';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { replaceAll, getObjectValue } from '@utility/utills';
import {
  setSeat, setPosition
} from '@reducers/orders';
import { getStorePickDeliveryTimes, checkOpen } from '@reducers/checks';
import { ReactComponent as ProfileIcon } from '@assets/images/profile_icon.svg';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import { ReactComponent as Clock } from '@assets/images/Clock.svg';
import Styles from '../OthersPopUpScreen/togo.module.scss';
import { LABEL } from '../../../veriables';
import { toggleTheme } from '@reducers/theme';
import { TouchableButton } from '@components/common/Touchable/index';
import ModalHeader from '@components/common/ModalHeader/index';
import CustomKeyboard from '@components/common/CustomKeyboardCopy/indexRevamp';
import { COUNTRY_CODE } from '@constants/index';
// import FullWithModal from '../../../components/common/Modal/FullWidthModal';
import EventEmitter from '@utility/eventSubscribers';
import {useNavigate} from 'react-router-dom';

const TogoCreateCheckModal = (props) => {
  const { editCallCenter, setSeat, seat, checkOpen, setNotification, getStorePickDeliveryTimes, serverAppTheme, isLandScape, setEditTogoModal,
    editTogoModal, isTogo, orderingPortraitOrientation } = props;
  const callCenterModeUserInfo = JSON.parse(window.sessionStorage.getItem('callCenterUserInfo'));
  const dropDownRef = useRef(null);
  const defaultCountryCode = getObjectValue(
    () => props?.auth?.country && COUNTRY_CODE[props.auth.country]?.dialCode,
    1
  );
  const [inputName, setInputName] = useState();
  const [keyboardType, setKeyboardType] = useState();
  const [openKeyboard, setOpenKeyboard] = useState(false);
  const [optionForDropdown, setOptionForDropdown] = useState([]);
  const [countryCode, setcountryCode] = useState(defaultCountryCode);
  const [typed, setTyped] = useState({});
  const authData = JSON.parse(window.sessionStorage.getItem('auth'));
  const callCenter = JSON.parse(window.sessionStorage.getItem('callCenter'));
  const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'));
  const [dropdownFirstVal, setdropdownFirstVal] = useState(true);
  const [browserOrtablet, setBrowserOrtablet] = useState(true);
  const [inputs, setInputs] = useState({
    checkName: editCallCenter ? callCenterModeUserInfo?.name : '',
    error: '',
    phoneNumber: editCallCenter ? callCenterModeUserInfo?.phoneNumber : getFormatedPhoneNumber(callCenter?.ANI),
    pickupTime: editCallCenter ? callCenterModeUserInfo?.pickupTime[0] : ''
  });
  const isServerApp = flowType() === 'serverApp';
  const serverAppThemeNumber = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme, '1');
  const keyboardRef = useRef(null);
  const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(
    getObjectValue(() => COUNTRY_CODE?.[props?.auth?.country]?.maxLength, 15)
  );
  const navigate = useNavigate();

  useLayoutEffect(() => {
    props.toggleTheme(serverAppThemeNumber);
  }, [])
  useLayoutEffect(() => {
      if (window.ReactNativeWebView) {
          if (orderingPortraitOrientation) {
            EventEmitter.changeOrientation({
              orientation: "portrait"
            })
          } else {
            EventEmitter.changeOrientation({
              orientation: "landscape"
            })
          }
      }
    }, [orderingPortraitOrientation])

  const itemsFilter = (array) => {
    return array.filter((e) => e.pending).map((e) => {
      return {
        ...e,
        ...JSON.parse(e.orderJson)
      };
    });
  };
  const setEmpty = (data) => {
    setInputs({
      ...inputs,
      [data]: '',
      error: '',
    });
    setTyped({
      ...typed,
      [data]: ''
    });
  };

  const tabletMode = (data) => {
    setInputName(data.name); setKeyboardType(data.type); setOpenKeyboard(data.board); handleBlur(data.blur)
  }
  const browserMode = (data) => {
    setInputName(data.name); setKeyboardType(data.type); setOpenKeyboard(data.board);
  }

  function pickUpTime(time) {
    if (time?.split(" ")[1] == "PM") {
      let timeVal = time?.split(" ")[0].substring(0, 2)
      if (timeVal !== "12") {
        timeVal = Number(timeVal) + 12;
        let timeVal2 = time?.split(" ")[0].substring(2)
        return timeVal + timeVal2;
      }
      return time?.split(" ")[0];
    } else {
      let timeVal = time?.split(" ")[0].substring(0, 2)
      if (timeVal === "12") {
        timeVal = Number(timeVal) - 12
        let timeVal2 = time?.split(" ")[0].substring(2)
        return timeVal + "0" + timeVal2;
      }
      return time?.split(" ")[0];
    }
  }
  const onClose = () => { setEditTogoModal(false) };
  const onClickContinue = () => {
    const dataToSend1 = {
      deviceId: deviceInfo?.deviceId,
      employeeId: Number(JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      storeId: deviceInfo?.storeId,
      phoneNumber: inputs.phoneNumber,
      countryCode,
      stationId: null,
      toGo: true,
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      name: inputs.checkName,
      stationGroupId: null,
      isTab: true,
      pickupTime: pickUpTime(inputs?.pickupTime),
      guestName: null,
      guestCount: 1,
      sourceType: 8,
      delivery: false,
      speedOrder: false,
    };
    const dataToSend2 = {
      deviceId: deviceInfo?.deviceId,
      employeeId: Number(JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      storeId: deviceInfo?.storeId,
      checkHeaderId: seat?.id,
      countryCode,
      phoneNumber: inputs.phoneNumber,
      name: inputs.checkName,
      pickupTime: pickUpTime(inputs?.pickupTime),
    };
    if (editCallCenter) {
      dataToSend2.pickupTime = [inputs.pickupTime];
      window.sessionStorage.setItem('callCenterUserInfo', JSON.stringify(dataToSend2));
      setEditTogoModal(false);
      navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true });
    }
    if (!editCallCenter) {
      checkOpen(dataToSend1, editCallCenter).then((val) => {
        dataToSend1.pickupTime = [inputs.pickupTime];
        window.sessionStorage.setItem('callCenterUserInfo', JSON.stringify(dataToSend1));
        !editCallCenter && setSeat({ ...val, pendingItems: itemsFilter((val.orders[0].items) || []) });

        const position = val?.seats?.find(e => e.open) ?? { number: -1, position: -1 };
        props.setPosition(position);

        editCallCenter ? setEditTogoModal(false) : navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true });
      }).catch((err) => {
        setNotification({
          type: 'danger',
          message: err.message
        });
      });
    }
  }


  const prependZero = (number) => {
    if (number < 10) return `0${number}`;
    return number;
  };
  const renderTime = (data) => {
    const options = [];
    data.forEach((time) => {
      const hour = Number(time.split(':')[0]);
      let name = '';
      if (hour === 0 || hour - 12 === 0) {
        name = `${12}:${time.split(':')[1]} ${hour > 0 ? 'PM' : 'AM'}`;
      } else if (Number(time.split(':')[0]) > 12) {
        name = `${prependZero(hour - 12)}:${time.split(':')[1]} PM`;
      } else if (Number(time.split(':')[0]) < 12) {
        name = `${prependZero(hour)}:${time.split(':')[1]} AM`;
      }
      options.push(name);
    });
    return options;
  };

  const getDeliveryTime = () => {
    const dataToSend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: authData.callCenterEmployeeId
    };
    getStorePickDeliveryTimes(dataToSend).then((val) => {
      let value = val.pickupTimes;
      // let value = ["3:00", "4:00"]
      value = renderTime(value);
      for (let i = 0; i < value.length; i++) {
        if (i == 0) {
          let a = value[i];
          a = a.concat(' (ASAP)')
          value[i] = a;
        }
      }
      setOptionForDropdown(value);
      setcountryCode("1");
      if (!editCallCenter || !inputs.pickupTime) {
        setInputs(prevInputs => ({ ...prevInputs, pickupTime: value[0] }));
      }
    }).catch((e) => {
      setcountryCode("1");
      setNotification({
        type: 'danger',
        message: e.message
      });
    });
  };

  useEffect(() => {
    getDeliveryTime();
    if (window.ReactNativeWebView) {
      setBrowserOrtablet(false);
    } else {
      setBrowserOrtablet(true);
    }
  }, []);

  const handleBlur = (value) => {
    const element = document.querySelector(value);
    element.blur();
  };

  const getInputValue = (inputNameDat) => {
    if (inputNameDat === 'phoneNumber' && countryCode === "1") {
      return (getFormatedPhoneNumber(inputs[inputNameDat])) || '';
    }
    return (inputs[inputNameDat]) || '';
  };

  const getOptions = (dropdownData) => {
    const values = dropdownData.map((item) => {
      return { id: item, name: item };
    });
    return values;
  };

  const onChangeInput = (event) => {
    const { name, value } = event.target;
    setInputs(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const closeKeyboard = () => {
    setOpenKeyboard(false);
  };
  const returnMaxLength = () => {
    if (inputs?.phoneNumber?.includes('-')) {
      return 10;
    }
    return phoneNumberMaxLength;
  };
  const onClickBtn = (e) => {
    const isBackspace = e === '{bksp}';
    const currentValue = typed[inputName] || '';
    const maxLength = returnMaxLength();

    if (
      inputName === 'phoneNumber' &&
      !isBackspace &&
      currentValue.length >= maxLength
    ) {
      return;
    }
    const newValue = isBackspace ? currentValue.slice(0, -1) : currentValue + e;

    setTyped({
      ...typed,
      [inputName]: newValue
    });

    setInputs({
      ...inputs,
      [inputName]:
        inputName === 'phoneNumber' && Number(countryCode) === 1
          ? getFormatedPhoneNumber(newValue)
          : newValue
    });
  };

  const validateTable = () => {
    const phoneLength = replaceAll(inputs.phoneNumber, '-');
    if (inputs?.checkName === '') {
      props.setErrorPopUp({ res: 'Name is required', noErrorTxt: true });
      return false;
    }

    if (inputs?.phoneNumber === '') {
      props.setErrorPopUp({ res: 'Phone number is required', noErrorTxt: true });
      return false;
    } else if (countryCode === "1" && inputs?.phoneNumber.length > 0 && phoneLength?.length < 10) {
      props.setErrorPopUp({ res: 'Phone number length must be 10 digits', noErrorTxt: true });
      return false;
    } else if (countryCode === "1" && phoneLength?.length > 10) {
      props.setErrorPopUp({ res: 'Phone number length must be 10 digits', noErrorTxt: true });
      return false;
    } else if (countryCode !== "1" && inputs?.phoneNumber.length > 0 && phoneLength?.length > 15) {
      props.setErrorPopUp({ res: 'Phone number length must be 15 digits', noErrorTxt: true });
      return false;
    }
    if (!inputs?.pickupTime) {
      props.setErrorPopUp({ res: 'PickUp time is required', noErrorTxt: true });
      return false;
    }
    return true;

  };
  const onContinue = () => {
    if (validateTable()) {
      onClickContinue();
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openKeyboard && keyboardRef.current && !keyboardRef.current.contains(event.target)) {
        const isInputField = event.target.id === 'checkName' || event.target.id === 'phoneNumber';
        if (!isInputField) {
          setOpenKeyboard(false);
        }
      }
    };

    if (openKeyboard) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [openKeyboard]);

  const guestInfoStyle = useMemo(() => {
    const splashScreenEdit = { right: '1rem', top: '1rem', backgroundColor: serverAppTheme.iconcolor_bg_box, borderRadius: "4px" }
    const editCallCenter = { right: '1rem', top: '1rem', borderRadius: "4px" }
    const container = { background: serverAppThemeNumber == '1' ? editCallCenter !== undefined ? '' : '#000' : '#f5f7fb', height: '100vh' }
    return { editCallCenter, splashScreenEdit, container }
  }, [serverAppThemeNumber, serverAppTheme]);
  return (
    <div style={guestInfoStyle.container}>
      <div className="col-12 h-100 px-0 py-0 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
        <div style={{ marginLeft: !editCallCenter }}>
          {/* {editCallCenter && ( */}
            <div style={{ color: serverAppTheme?.primary_text }}>
              <ModalHeader
                isTab={seat?.tab || false}
                // stationName={seat?.stationName || ''}
                tileHeader={editCallCenter ? LABEL().UPDATE_ORDER : LABEL().TOGO}
                // seatNumber={seat?.number || 0}
              />
            </div>
            <div className='mt-100'>
          {/* 1. Name input box */}
          <div
            className={cn(editCallCenter ? "col-12 mx-auto w-85 mt-100" :  orderingPortraitOrientation ? "col-12 mt-4" : "mt-4 row")}
            style={{ display: !editCallCenter ? "flex" : "", justifyContent: "center" }}
          >
            <div style={{ position: "relative" }} className={cn(orderingPortraitOrientation ? 'w-100' : '')}>
              <input
                value={getInputValue("checkName")}
                type="text"
                //ref={keyboard}
                className={cn(
                  "h-200 ", orderingPortraitOrientation ? 'w-100' : '',
                  editCallCenter ? "col-12 px-0" : "",
                  orderingPortraitOrientation ? Styles.inputFieldPortrait : Styles.inputField
                )}
                placeholder="Enter Guest Name"
                style={{
                  backgroundColor: serverAppTheme.input_box_background,
                  borderBottom: serverAppTheme?.inputBorder_Bottom,
                  color: serverAppTheme.primary_text,
                  "--placeholder-color": serverAppTheme?.input_placeholder,
                }}
                id="checkName"
                name="checkName"
                onFocus={() => {
                  browserOrtablet
                    ? browserMode({ name: "checkName", type: "kiosk", board: false })
                    : tabletMode({
                      name: "checkName",
                      type: "kiosk",
                      board: true,
                      blur: "#checkName",
                    });
                }}
                onChange={onChangeInput}
              />
              <div style={{ position: "absolute", top: orderingPortraitOrientation ? "16px" : "8px", left: "12px" }}>
                <ProfileIcon
                  height="1.6rem"
                  width="1.6rem"
                  fill={serverAppTheme.iconcolor}
                />
              </div>
              <div
                style={{ position: "absolute", right: "6px", top: orderingPortraitOrientation ? "15px" : "6px" }}
                tabIndex="0"
                role="button"
                onClick={() => {
                  setEmpty("checkName");
                }}
              >
                <Cross fill={serverAppTheme.iconcolor} />
              </div>
            </div>
            {inputs?.error && (
              <div className="col-10 fs-12 text-primary text-right mr-20">
                {inputs.error.checkName}
              </div>
            )}
          </div>
          {/* 2. Phone number input box */}
          <div
            className={cn(
              editCallCenter ? "col-12 mx-auto w-85" : "",
              "text-center mt-3", orderingPortraitOrientation ? 'col-12' : 'row'
            )}
            style={{ display: "flex", justifyContent: "center", position: "relative" }}
          >
            <PhoneNumberComponent
              countryCode={countryCode}
              handleCountryCodeChange={(e) => {
                setcountryCode(e.id);
              }}
              styles={{
                width: "19%",
                left: editCallCenter ? "0px" : !orderingPortraitOrientation ?  "87px" : '30px',
                height: "44px",
                padding: "p-2",
                zIndex: 9999,
                lineHeight: "normal",
                top: orderingPortraitOrientation ? '10px' : '0'
              }}
              GuestInformationPhone={true}
              serverAppTheme={serverAppTheme}
              isLandScape={isLandScape}
              screenType="callCenterLogin"
              editCallCenter={editCallCenter}
              isTogo={isTogo}
              isOrderingPortrait={orderingPortraitOrientation}
            />
            <input
              value={getInputValue("phoneNumber")}
              //ref={keyboard}
              type="text"
              className={cn(editCallCenter ? "col-12 px-0" : "", "h-200", orderingPortraitOrientation ? 'w-100' : '', orderingPortraitOrientation ? Styles.inputFieldPortrait : Styles.inputField)}
              placeholder="Enter Phone Number"
              style={{
                backgroundColor: serverAppTheme.input_box_background,
                borderBottom: serverAppTheme?.inputBorder_Bottom,
                color: serverAppTheme.primary_text,
                "--placeholder-color": serverAppTheme?.input_placeholder,
              }}
              id="phoneNumber"
              name="phoneNumber"
              maxLength={countryCode === "1" ? browserOrtablet ? '12' : "11" : "15"}
              onFocus={() => {
                browserOrtablet
                  ? browserMode({ name: "phoneNumber", type: "number", board: false })
                  : tabletMode({
                    name: "phoneNumber",
                    type: "number",
                    board: true,
                    blur: "#phoneNumber",
                  });
              }}
              onChange={onChangeInput}
              autoComplete="off"
            />
            <div
              style={{
                position: "absolute",
                right:  orderingPortraitOrientation ? '20px' : '107px',
                top: orderingPortraitOrientation ? "15px" : "6px",
              }}
              tabIndex="0"
              role="button"
              onClick={() => {
                setEmpty("phoneNumber");
              }}
            >
              <Cross fill={serverAppTheme.iconcolor} />
            </div>

            {inputs?.error && (
              <div className="text-right mr-20 col-10 fs-12 text-primary">
                {inputs.error.phoneNumber}
              </div>
            )}
          </div>
          {/* 3. Time input box */}
          <div
            className={cn(
              !editCallCenter
                ? "justify-content-center"
                : "mx-auto col-12 justify-content-center",
              "text-center mt-3", orderingPortraitOrientation ? 'col-12' : 'row'
            )}
            style={
              optionForDropdown.length !== 1
                ? {
                  width: editCallCenter ? "90%" : "",
                  height: editCallCenter ? "10vh" : "",
                }
                : {
                  width: editCallCenter
                    ? "100%"
                    : optionForDropdown.length !== 1
                      ? "95%"
                      : "",
                }
            }
          >
            {optionForDropdown.length !== 1 ? (
              <div
                className={cn(
                  "position-relative ",
                  orderingPortraitOrientation ? Styles.inputFieldPortrait : Styles.inputField,
                  Styles.textIndentNone,
                  orderingPortraitOrientation ? 'w-100' : '',
                )}
                style={{
                  backgroundColor: serverAppTheme.input_box_background,
                  borderBottom: serverAppTheme?.inputBorder_Bottom,
                  color: serverAppTheme.primary_text,
                }}
              >
                <SimpleReactSelect
                  className={cn(
                    editCallCenter ? "w-100" : "",
                    "od-text-secondary text-secondary fs-12 text-start px-2",
                    orderingPortraitOrientation ? Styles.SimpleReactPortrait : Styles.SimpleReactSelectHeight,
                  )}
                  style={{
                    position: "relative",
                    fontSize: "3.5vh",
                    height: "10vm",
                    lineHeight: "5vm",
                    left: "150px",
                    marginLeft: "-240px",
                  }}
                  ref={dropDownRef}
                  maxMenuHeight={140}
                  onChange={(data) => {
                    setInputs({ ...inputs, pickupTime: data ? data?.id : "" });
                    setdropdownFirstVal(false);
                  }}
                  // isClearable
                  options={getOptions(optionForDropdown)}
                  name="job"
                  value={inputs.pickupTime ? { id: inputs.pickupTime, name: inputs.pickupTime } : null}
                  defaultValue={
                    dropdownFirstVal
                      ? editCallCenter
                        ? callCenterModeUserInfo?.pickupTime[0]
                        : optionForDropdown[0]
                      : null
                  }
                  placeholder="Choose Pickup Time"
                  serverAppTheme={serverAppTheme}
                  screenType="callCenter"
                  GuestInformation={true}
                  editCallCenter={editCallCenter}
                />
                <div style={{ position: "absolute", top: orderingPortraitOrientation ? '15px' : "5px", left: "10px" }}>
                  <Clock height="1.9rem" width="1.9rem" fill={serverAppTheme.iconcolor} />
                </div>
              </div>
            ) : (
              <div
                className={cn(
                  editCallCenter ? "px-0 mx-0" : "",
                  "text-center row position-relative",
                )}
              >
                <input
                  value={optionForDropdown[0]}
                  type="text"
                  className={cn(
                    "h-200 opacity-30",
                    editCallCenter ? "col-12" : "",
                    orderingPortraitOrientation ? Styles.inputFieldPortrait : Styles.inputField
                  )}
                  placeholder="Pick up time"
                  style={{
                    borderBottom: serverAppTheme?.inputBorder_Bottom,
                    backgroundColor: serverAppTheme.input_box_background,
                    textIndent: editCallCenter ? "138px" : "153px",
                    color: serverAppTheme.primary_text,
                  }}
                  id="checkName"
                  name="checkName"
                  readOnly
                />
                <div className={cn("position-absolute", Styles.clockIcon)}>
                  <Clock height="1.9rem" width="1.9rem" fill={serverAppTheme.iconcolor} />
                </div>
              </div>
            )}
            {inputs?.error && (
              <div className="text-right col-10 fs-12 text-primary pr-4">
                {inputs.error.pickupTime}
              </div>
            )}
          </div>
          </div>
        </div>
        {openKeyboard ? (
          <div ref={keyboardRef} className={cn('p-0 m-0 background-primary od-app-background-color', Styles.keyboard1, orderingPortraitOrientation ? Styles.keyBoardPortrait : Styles.keyboardLandScape)}>
            <div className={cn('col-12 p-0 text-right position-absolute', Styles.arrow)}>
            </div>
            {/* <CustomKeyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={(e) => onClickBtn(e)}
              type={keyboardType}
              typed={typed[inputName] || ''}
              closeKeyboard={closeKeyboard}
              btnSize="btn35"
              customClass="fs-30 background-primary od-app-background-color"
            /> */}
            <CustomKeyboard
              setKeyboardType={setKeyboardType}
              onClickBtn={e => onClickBtn(e)}
              type={(inputName === 'phoneNumber')
                ? 'numericAlpha'
                : 'textDefaultCaps'
              }
              typed={typed[inputName] || ''}
              closeKeyboard={closeKeyboard}
              btnSize="fs-18"
              customClass={`h-auto mt-auto p-2`}
              spacebtn={!isLandScape && Styles.spacebtn}
              screenType="checkCreate"
              isAlphaNumericFlag={true}
              // setIsDoneClick={setIsDoneClick}
              tableKeyHeight={true}
              callApi={true}
              maxLength={
                inputName === 'phoneNumber' && returnMaxLength()}
            />
          </div>) : <></>}
        <div
          className={cn(
            'col-12 d-flex align-items-end px-0 justify-content-center position-fixed bottom-0 start-0 mt-4',
            Styles.btnPosition2
          )}
        >
          <div className={cn("pr-1", orderingPortraitOrientation ? 'col-6' : 'col-5')}>
            <TouchableButton
              type="button"
              className={cn(
                'px-0 mb-3 mt-2 rounded btn-ripple fs_24 fw-600 w-100',
                orderingPortraitOrientation ? 'btn68' : 'btn44'
              )}
              style={{
                backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                border: serverAppTheme?.cancleBtn_Border,
                color: serverAppTheme?.cancleBtn_font,
              }}
              onClick={e => {
                e.preventDefault();
                onClose();
              }}
              rippleEffect={true}
            >
              {LABEL().CANCEL}
            </TouchableButton>
          </div>
          <div className={cn("pl-1", orderingPortraitOrientation ? 'col-6' : 'col-5')}>
            <TouchableButton
              type="submit"
              className={cn(
                'btn-ripple  fs_24 fw-600 w-100 d-flex align-items-center justify-content-center mb-3 mt-2',
                orderingPortraitOrientation ? 'btn68' : 'btn44'
                )}
              style={{
                backgroundColor: serverAppTheme?.secondaryBtn,
                color: serverAppTheme?.btn_font_color,
              }}
              onClick={(e) => {
                e.preventDefault();
                onContinue()
              }}
              rippleEffect={true}
            >
              {LABEL().CONTINUE}
            </TouchableButton>
          </div>
        </div>

      </div>
    </div>
  );
};

const mapStateToProps = ({
  orders,
  oauth,
  theme
}) => ({
  isHeight: orders.isHeight,
  deviceInfo: oauth.deviceInformation,
  serverAppTheme: theme.serverAppTheme,
  orderingPortraitOrientation: orders.orderingPortraitOrientation,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getStorePickDeliveryTimes,
  checkOpen,
  setSeat,
  setNotification,
  toggleTheme,
  setErrorPopUp,
  setPosition
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TogoCreateCheckModal);
